var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enroll-view"},[(!_vm.$route.params.email)?_c('p',{staticClass:"text"},[_vm._v("Preparing your new cohort...")]):_c('p',{staticClass:"text"},[_vm._v("Redirecting to our identity providers...")]),_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }